import { useFriend } from '@/hooks/contacts/use-friends';
import { useGroupMember } from '@/hooks/groups/use-group-members';

interface Options {
  groupId?: number;
  defaultName?: Nullable<string>;
  defaultAvatar?: Nullable<string>;
}

interface UserDisplayInfo {
  name: string;
  avatarUrl: Nullable<string>;
  role: number;
}

export default function useUserDisplayInfo(
  userId: Nullable<number>,
  { defaultName, defaultAvatar, groupId }: Options,
): UserDisplayInfo {
  const { friend } = useFriend(userId);
  const { data: member } = useGroupMember(groupId, userId);

  let name = defaultName;
  let avatarUrl = defaultAvatar;
  let role = 0;

  if (!userId)
    return {
      name: defaultName || '',
      avatarUrl: defaultAvatar || '',
      role,
    };

  name = friend?.RemarkName || member?.GroupMemberName || defaultName;
  avatarUrl = friend?.FriendHeadImg || defaultAvatar;
  role = member?.Role || 0;

  return {
    name: name || '',
    avatarUrl: avatarUrl || '',
    role,
  };
}
